<template>
  <main id="page-wrap" class="v2-matches">
    <div class="grid-container">
      <div class="grid-x align-center">
        <div class="cell small-12 medium-10 large-8">
          <h1>Mina byten</h1>

          <div v-if="v2MatchesLoading && !v2Matches.length" class="v2m-loading">
            {{ $t('general.loading') }}…
          </div>

          <div v-else-if="!v2Matches.length" class="v2m-empty">
            <p>Du har inga matchningar än.</p>
          </div>

          <ul v-else class="v2m-list">
            <li v-for="m in v2Matches" :key="m.match_id" class="v2m-item">
              <div class="v2m-item__photo">
                <img v-if="photoUrl(m)" :src="photoUrl(m)" :alt="m.moving_to.street">
              </div>
              <div class="v2m-item__body">
                <div class="v2m-item__head">
                  <h3>{{ m.moving_to.street }} {{ m.moving_to.street_number }}</h3>
                  <span class="v2m-item__size">{{ sizeLabel(m.size) }}</span>
                </div>
                <p class="v2m-item__hood">
                  <span v-if="m.moving_to.hood">{{ m.moving_to.hood }}, </span>{{ m.moving_to.city }}
                </p>
                <ul class="v2m-item__stats">
                  <li v-if="m.moving_to.rooms != null">{{ m.moving_to.rooms }} {{ $t('ad.rooms') }}</li>
                  <li v-if="m.moving_to.size != null">{{ m.moving_to.size }} m²</li>
                  <li v-if="m.moving_to.rent != null">{{ m.moving_to.rent }} kr/{{ $t('ad.month') }}</li>
                </ul>
                <p class="v2m-item__when">
                  Matchad {{ formatDate(m.matched_at) }}
                </p>

                <ul v-if="m.via && m.via.length" class="v2m-item__via">
                  <li v-for="via in m.via" :key="via.ad_id" class="v2m-via">
                    <div class="v2m-via__photo">
                      <img v-if="viaPhoto(via)" :src="viaPhoto(via)" :alt="via.street">
                    </div>
                    <p class="v2m-via__label">{{ via.street }} {{ via.street_number }}</p>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { mapState } from 'vuex'
import { v2PhotoUrl } from '@/utils/v2Photo'
import { swapSizeLabel } from '@/utils/swapMeta'

export default {
  name: 'V2Matches',
  computed: {
    ...mapState('swaps', ['v2Matches', 'v2MatchesLoading'])
  },
  mounted () {
    this.$store.dispatch('swaps/fetchV2Matches')
  },
  methods: {
    photoUrl (match) {
      return v2PhotoUrl(match.moving_to && match.moving_to.photo)
    },
    viaPhoto (via) {
      return v2PhotoUrl(via.photo)
    },
    sizeLabel (size) {
      return swapSizeLabel(size)
    },
    formatDate (isoString) {
      if (!isoString) return ''
      // API returns "2026-02-07 20:57:46" — render as "2026-02-07"
      return isoString.split(' ')[0]
    }
  }
}
</script>

<style scoped>
.v2-matches {
  margin-top: 74px;
  padding-bottom: 40px;
}

.v2-matches h1 {
  margin-bottom: 16px;
}

.v2m-loading,
.v2m-empty {
  padding: 32px 16px;
  text-align: center;
  color: #666;
  background: #fff;
  border-radius: 6px;
}

.v2m-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.v2m-item {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  padding: 14px;
  margin-bottom: 12px;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

@media (min-width: 640px) {
  .v2m-item {
    grid-template-columns: 200px 1fr;
  }
}

.v2m-item__photo {
  width: 100%;
  aspect-ratio: 4 / 3;
  overflow: hidden;
  border-radius: 4px;
  background: #eee;
}

.v2m-item__photo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.v2m-item__head {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 8px;
}

.v2m-item__head h3 {
  margin: 0;
  font-size: 1.1rem;
}

.v2m-item__size {
  padding: 2px 8px;
  background: #e8f5f2;
  color: #2a7a6d;
  border-radius: 10px;
  font-size: 0.75rem;
  font-weight: 600;
  white-space: nowrap;
}

.v2m-item__hood {
  margin: 2px 0 8px;
  font-size: 0.85rem;
  color: #666;
}

.v2m-item__stats {
  list-style: none;
  padding: 0;
  margin: 0 0 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  font-size: 0.85rem;
  color: #333;
}

.v2m-item__when {
  margin: 0 0 10px;
  font-size: 0.75rem;
  color: #888;
}

.v2m-item__via {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.v2m-via {
  width: 80px;
}

.v2m-via__photo {
  width: 80px;
  height: 60px;
  border-radius: 4px;
  overflow: hidden;
  background: #eee;
}

.v2m-via__photo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.v2m-via__label {
  margin: 4px 0 0;
  font-size: 0.72rem;
  color: #555;
  line-height: 1.1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
